import { useEffect, useState } from "react";
import type { AttendeeSession, AttendeeUpdateList, PublicUpdate } from "@verity-connect/contracts";
import { useAttendeeStateEpoch } from "./cross-device-state";

export function useAttendeeUpdates(
  session: AttendeeSession | null,
  eventSlug: string,
  publicUpdates: readonly PublicUpdate[],
  online: boolean,
): readonly PublicUpdate[] {
  const signal = useAttendeeStateEpoch();
  const [personal, setPersonal] = useState<{ identityId: string; updates: readonly PublicUpdate[] } | null>(null);

  useEffect(() => {
    setPersonal(null);
    if (!session || !online) return;
    const controller = new AbortController();
    void fetch(`/api/attendee/events/${encodeURIComponent(eventSlug)}/updates`, { credentials: "same-origin", signal: controller.signal })
      .then(async (response) => {
        if (!response.ok) throw new Error("Personal updates could not be loaded.");
        setPersonal({ identityId: session.identityId, updates: (await response.json() as AttendeeUpdateList).updates });
      })
      .catch(() => { /* The public Updates center remains usable if personalization cannot load. */ });
    return () => controller.abort();
  }, [eventSlug, session?.identityId, online, publicUpdates, signal.epoch]);

  return session && personal?.identityId === session.identityId ? personal.updates : publicUpdates;
}
